import { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Divider,
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 600,
  maxHeight: '90vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const AddressModal = ({ open, onClose, address, onUpdate, onDelete }) => {
  const [formData, setFormData] = useState({ ...address });

  useEffect(() => {
    setFormData({ ...address });
  }, [address]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCheckboxChange = () => {
    setFormData((prev) => ({
      ...prev,
      is_same_as_delivery: !prev.is_same_as_delivery,
    }));
  };

  const handleSubmit = () => {
    onUpdate(formData);
  };

  const handleDelete = () => {
    onDelete(formData.id);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" mb={2}>
          Adres Bilgisi
        </Typography>

        {/* Normal Adres */}
        <Box mb={3} display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Adres Başlığı"
            value={formData.title || ''}
            onChange={(e) => handleChange('title', e.target.value)}
            fullWidth
          />
          <TextField
            label="Adres"
            multiline
            rows={3}
            value={formData.address || ''}
            onChange={(e) => handleChange('address', e.target.value)}
            fullWidth
          />
          <TextField
            label="İlçe"
            value={formData.state || ''}
            onChange={(e) => handleChange('state', e.target.value)}
            fullWidth
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_same_as_delivery}
                onChange={handleCheckboxChange}
              />
            }
            label="Teslimat ve fatura adresi aynı"
          />
        </Box>

        {/* Fatura Adresi */}
        {!formData.is_same_as_delivery && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" fontWeight="bold" mb={2}>
              Fatura Adresi
            </Typography>

            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                label="Ad Soyad"
                value={formData.full_name || ''}
                onChange={(e) => handleChange('full_name', e.target.value)}
                fullWidth
              />
              <TextField
                label="Vergi Numarası"
                value={formData.tax_number || ''}
                onChange={(e) => handleChange('tax_number', e.target.value)}
                fullWidth
              />
              <TextField
                label="Vergi Dairesi"
                value={formData.tax_office || ''}
                onChange={(e) => handleChange('tax_office', e.target.value)}
                fullWidth
              />
              <TextField
                label="Fatura Adresi"
                multiline
                rows={3}
                value={formData.billing_address  || ''}
                onChange={(e) => handleChange('billing_address', e.target.value)}
                fullWidth
              />
              <TextField
                label="İlçe (Fatura)"
                value={formData.district || ''}
                onChange={(e) => handleChange('district', e.target.value)}
                fullWidth
              />
            </Box>
          </>
        )}

        {/* Butonlar */}
        <Box mt={4} display="flex" justifyContent="space-between">
          <Button onClick={handleDelete} color="error" variant="outlined">
            Sil
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Güncelle
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddressModal;
